// src/pages/Community.js

import { Helmet } from 'react-helmet';

// Component'ları import ediyoruz
import VideoHero from '../components/shared/VideoHero';
import ContentSection from '../components/ContentSection';
import CommunityGallery from '../components/CommunityGallery';
import CommunityCarousel from '../components/CommunityCarousel';


const Community = () => {
  return (
    <>
      <Helmet>
        <title>Our Community | Little Hibba</title>
        <meta name="description" content="Where stories, sisters, and support come to life. Discover how Little Hibba brings stories to life through community events and workshops." />
      </Helmet>

      {/* 1. Hero Bölümü (Video Banner) */}
      {/* GÜNCELLENDİ: Yeni tagline prop'u eklendi */}
      <VideoHero 
        title="Our Community" 
        tagline="Where stories, sisters, and support come to life."
      />

      {/* ... sayfanın geri kalanı aynı ... */}
      <ContentSection
        title="From Books to Community"
        text="At Little Hibba, we believe stories don’t just live on the page — they live in people. That’s why we take our books beyond the bookshelf and into the heart of our communities. Through family-friendly events, school workshops, and creative gatherings, we bring stories to life in ways that spark imagination, build confidence, and nurture connection."
        imageSrc="/images/community/community (1).jpg"
        imageAlt="Children reading books at a community event"
        imagePosition="left"
      />
      
      <CommunityCarousel />

      <ContentSection
        title="Spaces to Create & Celebrate"
        text="Our events are more than just storytime. They are spaces where children and families can explore, create, and celebrate together. From hands-on storytelling workshops to cultural festivals and charity partnerships, we use stories as a bridge — connecting generations, strengthening identity, and inspiring positive change."
        imageSrc="/images/community/community (2).jpg"
        imageAlt="Family participating in a creative workshop"
        imagePosition="right"
      />

      <CommunityGallery />

      <ContentSection
        title="Rooted in Diversity & Inclusion"
        text="As a diverse publishing house, our work is rooted in the values of diversity, equity, and inclusion (DEI). We know every child deserves to see themselves reflected in stories and every family deserves to feel that they belong. That’s why our events celebrate voices and traditions that are often underrepresented."
        imageSrc="/images/community/community (7).jpg"
        imageAlt="Diverse group of children at a cultural festival"
        imagePosition="left"
      />
           
    </>
  );
};

export default Community;
